import { Box } from '@mui/system';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { Button } from '@mui/material';
import ClassNames from 'classnames';

const useStyles = makeStyles({
  buttonBox: {
    overflow: 'hidden',
  },
  root: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    margin: '30px 0',

    '@media only screen and (max-width: 900px)': {
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },

    '@media only screen and (max-width: 768px)': {
      maxWidth: '400px',
      paddingLeft: '8px',

      overflow: 'scroll',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',

      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
    // '@media only screen and (max-width: 400px)': {
    //   maxWidth: '270px',
    // },
  },

  button: {
    color: '#191919 !important',
    fontWeight: 'normal',
    marginRight: '30px !important',
    fontSize: '16px !important',

    '& span': {
      fontSize: '16px !important',
    },
    '&.active': {
      fontWeight: 600,
    },

    '@media only screen and (max-width: 1024px)': {
      marginRight: '20px !important',
      fontSize: '14px !important',
    },

    '@media only screen and (max-width: 900px)': {
      margin: '0 !important',
      padding: '14px 22px',
      border: 'solid 1px #707070',
      backgroundColor: '#f4f6f9',
    },
    '@media only screen and (max-width: 768px)': {
      fontSize: '11px !important',
      minWidth: '136px !important',
      marginRight: '14px !important',
      minHeight: '40px',
      borderRadius: '28px !important',
      border: 'solid 1px #707070 !important',
      backgroundColor: '#fff !important',
    },
  },
});
export default function Filter(props) {
  const { filterList, buttonClick, filterName } = props;
  const classes = useStyles();
  return (
    <Box className={classes.buttonBox}>
      <Box className={classes.root}>
        <Button className={ClassNames({ [classes.button]: true, active: !!filterName && filterName === 'all' })} onClick={buttonClick}>
          all
        </Button>
        {filterList.map((i) => {
          return (
            <Button className={ClassNames({ [classes.button]: true, active: !!filterName && filterName === i.category })} key={i.category} onClick={buttonClick}>
              {i.category}
            </Button>
          );
        })}
      </Box>
    </Box>
  );
}
